import common from '@page/common/js/common';
import useGlobalLayout from '@global/composable/useGlobalLayout';
import useFreeLayout from '@global/composable/useFreeLayout';
import $ from 'jquery';

const { globalLayout } = useGlobalLayout();
const { initSlick, transitionEffects } = useFreeLayout();

const HomeContent = function () {
  $(window).scroll();
  $('.main').css({ visibility: 'visible' }).addClass('js-loaded');
  $('.home-loading').fadeOut();
};

HomeContent();

initSlick();
transitionEffects();

globalLayout({
  banner: {
    isOpen: false,
    opts: {
      dots: false,
      arrows: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 3000,
    },
    squareOpts: {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      speed: 800,
      responsive: [
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            dots: false,
          },
        },
      ],
    },
    fullBanner: {
      play: 5000,
    },
  },
  popupOpen: true,
  popupShowOnce: false,
});
